import {PreferenceCenter} from "./PreferenceCenter";
import {submitData} from "../helpers/PreferenceCenterProxyHelper"

export class OptOut extends PreferenceCenter {

    sendData(endpoint, data, callback) {
        data = this.cleanFields(data)

        //remove all values except for email
        Object.keys(data)
            .filter(f => f !== 'Email')
            .map(f => data[f] = '')

        //Hard set unsubscribe data
        data.Unsubscribed = "Yes"
        data.Email_Blast_OK__c = "No"

        submitData(endpoint, data, callback)
    }
}

